'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.singleton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _RUMUtil = require('../utils/RUMUtil');

var _RUMUtil2 = _interopRequireDefault(_RUMUtil);

var _EventPumpAbstract2 = require('./EventPumpAbstract');

var _EventPumpAbstract3 = _interopRequireDefault(_EventPumpAbstract2);

var _VideoManager = require('../video/VideoManager');

var _VideoManager2 = _interopRequireDefault(_VideoManager);

var _EventConstants = require('../models/EventConstants');

var _EventConstants2 = _interopRequireDefault(_EventConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IDLE = 'IDLE';
var HTTP = 'HTTP';
var INBAND = 'INBAND';

// exporting this so users can do some validating of their own
var singleton = exports.singleton = Symbol.for('instance');
var singletonEnforcer = Symbol.for('enforcing');

var EventPumpAudience = function (_EventPumpAbstract) {
  _inherits(EventPumpAudience, _EventPumpAbstract);

  function EventPumpAudience(enforcer) {
    var _this2 = this;

    _classCallCheck(this, EventPumpAudience);

    if (enforcer !== singletonEnforcer) {
      throw new Error('Cannot construct a singleton');
    }

    var _this = _possibleConstructorReturn(this, (EventPumpAudience.__proto__ || Object.getPrototypeOf(EventPumpAudience)).call(this, { isProducer: false }));

    _this.playingHandler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var status, hasEventCompleted, eventId, accountId, componentEventHost, getCatchUpEvents, dataHandler, eventList;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              status = _this.eventModel.event.status;
              hasEventCompleted = _EventConstants2.default.EventStatusEnum.hasEventCompleted;

              /**
               * for live events only, in case any CEs were missed,
               * run catch-up events when playback starts.
               *
               * on first load pumpStatus will be IDLE, and we don't
               * want to run this if HTTP (polling) so we're going to
               * run catch-up if player was already playing and pumpStatus was INBAND
               *
               * a minor caveat - if CEs are fired while a user is buffering,
               * it's possible that when the player recovers and we run catch-up events,
               * the viewer may receive component events prior to the playhead time
               * that they're supposed to occur. This can lead to seeing component events
               * replayed as they come through the stream and is no different than a user
               * joining the event for the first time..
               *
               * we currently have no way of processing component events in a
               * time-based manner since catch-up events do not contain any time data
               *
               */

              if (hasEventCompleted(status)) {
                _context.next = 16;
                break;
              }

              if (!(_this.pumpStatus === INBAND)) {
                _context.next = 16;
                break;
              }

              console.log('Playback started, running catch-up');
              _context.prev = 5;
              eventId = _this.eventId, accountId = _this.accountId, componentEventHost = _this.componentEventHost, getCatchUpEvents = _this.getCatchUpEvents, dataHandler = _this.dataHandler;
              _context.next = 9;
              return getCatchUpEvents(eventId, accountId, componentEventHost);

            case 9:
              eventList = _context.sent;

              dataHandler(eventList);
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](5);

              _RUMUtil2.default.addError(_context.t0);

            case 16:
              // close the http manager, the VideoManager is subscribed
              // and ready to handle timed (in-band) events.
              console.log('Video stream is live and ready to receive inBand events. Closing event pump manager...');
              _this.httpManager.close();
              _this.pumpStatus = INBAND;
              _this.emit('stopPollingComponentEvents');

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[5, 13]]);
    }));

    _this.fallbackErrorHandler = function () {
      // start polling until (and if) video is reconnected.
      console.warn('There has been an unexpected error with the video stream. ' + 'Temporarily falling back to HTTP polling on last inBand eventId: ' + _this.lastInBandEventId);
      _this.pumpStatus = IDLE;
      _this.startHttpPolling(_this.accountId, _this.eventId, _this.componentEventHost);
    };

    _this.inBandEventHandler = function (evt) {
      var inBandEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var parsedData = inBandEvent;

      if ((0, _isEmpty2.default)(parsedData)) {
        return false;
      }

      // unpack the component event from the response object
      // format: {data: [{accountId, eventId, payload}], pagination: {next, count}}
      // data.payload is the component event array needed, while pagination.next is the id to store
      _this.dataHandler(parsedData.data);
      if (!(0, _isUndefined2.default)(parsedData.pagination)) _this.lastInBandEventId = parsedData.pagination.next;

      return true;
    };

    _this.startHttpPolling = function (accountId, eventId, componentEventHost) {
      var previewToken = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (!_this.areValidParams(accountId, eventId, componentEventHost)) {
        throw new Error('\n        Parameters not valid\n        eventId: ' + eventId + '\n        accountId: ' + accountId + '\n        componentEventHost: ' + componentEventHost + '\n      ');
      }

      if (_this.pumpStatus !== IDLE) {
        console.log('[EventPumpAudience] Pump status is ' + _this.pumpStatus + ', so not starting polling again.');
        return;
      }

      _this.accountId = accountId;
      _this.eventId = eventId;
      _this.componentEventHost = componentEventHost;

      _this.pumpStatus = HTTP;
      _this.httpManager.open(accountId, eventId, componentEventHost, previewToken, _this.eventModel ? _this.eventModel.event.status : null, _this.lastInBandEventId);
    };

    _this.videoManager = new _VideoManager2.default(_this.inBandEventHandler, _this.fallbackErrorHandler, _this.playingHandler);

    _this.pumpStatus = IDLE;
    _this.accountId = null;
    return _this;
  }

  _createClass(EventPumpAudience, [{
    key: 'destroyVideoPlayer',
    value: function destroyVideoPlayer() {
      this.videoManager.destroyPlayer();
    }
  }], [{
    key: 'instance',
    get: function get() {
      if (!EventPumpAudience[singleton]) {
        EventPumpAudience[singleton] = new EventPumpAudience(singletonEnforcer);
      }

      return EventPumpAudience[singleton];
    }

    // fires on "playing" event, and indicates successful playback


    /**
     * This is the error handler that fires on a "FAILOVER_RETRY_LIMIT_REACHED" event in the video player.
     * If this fires, that means the video player has failed to connect to a video stream from the list
     * of video URLs and has decided to give up.
     * We need to begin polling from the point of the last inBand component event id that was processed.
     */

  }]);

  return EventPumpAudience;
}(_EventPumpAbstract3.default);

exports.default = EventPumpAudience;